import Vue from "vue";
import base from "./baseAuth";

export default Object.assign(
    {
        apiUrl: "/account",

        async alterLogo({ data }) {
            const options = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: localStorage.getItem("token")
                }
            };

            return Vue.http.post(
                this.userUrl({
                    path: "/logo"
                }),
                data,
                options
            );
        },

        async listPermissions({ accountType }) {
            const url = this.url(`/permissions/${accountType}`);

            return Vue.http.get(url);
        },

        async getAccountDomain(){
            return Vue.http.get('/auth/account/domain')
        },

        async updateAccountDomain(domain){
            return Vue.http.patch('/auth/account/domain', { domain })
        }
    },
    base
);
